import { IconButton, Stack, Tooltip } from "@mui/material";
import DeleteIcon from "src/assets/svg-icons/aggregators/delete.svg";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { notificationsState } from "src/store/notifications";
import { useTranslation } from "react-i18next";
import { ConfirmPopup } from "src/shared/components/confirm-popup";
import { oneBranchHasPermission } from "src/utils";
import { PurchasingPermissions } from "src/constants/permissions";
import EditIcon from "src/assets/svg-icons/aggregators/edit.svg";
import AddEditJournalPopup from "../../add-edit-journal";
import { useDeleteManualJournalMutation } from "src/api/events/manual-journals";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

interface IAction {
  row: any;
  refetch: Function;
}

const TableActions = (props: IAction) => {
  const { t } = useTranslation("general");
  const { row, refetch } = props;
  const { id, reference } = row;
  const [openDelete, setOpenDelete] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [isViewing, setIsViewing] = useState(false);

  const [notifications, setNotifications] = useRecoilState(notificationsState);

  // APIS
  const { mutate, isPending, status, error } = useDeleteManualJournalMutation();

  //permissions
  const deletePermission = oneBranchHasPermission(
    PurchasingPermissions.deleteEvent,
  );

  const handleOpenDelete = () => setOpenDelete(true);
  const handleCloseDelete = () => setOpenDelete(false);

  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  const handleView = () => {
    setIsViewing(true);
    handleOpenEdit();
  };

  const handleDelete = () => {
    mutate(id);
  };

  useEffect(() => {
    if (status === "success") {
      refetch();
      handleCloseDelete();
      setNotifications([
        ...notifications,
        {
          type: "success",
          message: t("deletedSuccessfully"),
        },
      ]);
    } else if (status === "error") {
      setNotifications([
        ...notifications,
        {
          type: "error",
          message: error?.data.errors[0].value || t("somethingWrong"),
        },
      ]);
    }
  }, [status]);

  return (
    <Stack direction={"row"} spacing={"12px"} justifyContent={"center"}>
     

      <Tooltip title={t("edit")}>
        <IconButton onClick={handleOpenEdit}>
          <img src={EditIcon} alt="" />
        </IconButton>
      </Tooltip>

      {deletePermission && (
        <Tooltip title={t("delete")}>
          <IconButton onClick={handleOpenDelete}>
            <img src={DeleteIcon} alt="" />
          </IconButton>
        </Tooltip>
      )}

      <Tooltip title={t("details")}>
        <IconButton onClick={handleView}>
          <VisibilityOutlinedIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      {/* confirm delete popup */}
      <ConfirmPopup
        open={openDelete}
        item={reference}
        handleClose={handleCloseDelete}
        handleConfirm={handleDelete}
        isPending={isPending}
      />
      {/* edit popup */}
      {openEdit && (
        <AddEditJournalPopup
          open={openEdit}
          handleClose={handleCloseEdit}
          dataToEdit={row}
          refetch={refetch}
          isViewing
        />
      )}
    </Stack>
  );
};
export default TableActions;
